import { FC, useMemo } from 'react';
import { MenuItemVariantDto } from '../../../../generated-api';
import Item from './Item';

interface Props {
  items: MenuItemVariantDto[];
}

const Items: FC<Props> = ({ items }) => {
  const itemsList = useMemo(() => {
    return items.map((item) => <Item key={item.variantLinkId} item={item} />);
  }, [items]);

  return <section className="grid grid-cols-12 auto-rows-min gap-4">{itemsList}</section>;
};
export default Items;
